// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-styles___paper--qqk6g {
  padding: 32px 32px 0;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-CompanyDetails-styles___statusUpdate--ZAjkP {
  padding: 17px 30px 0px 30px;
}

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___button--lVINt {
    width: 93px !important;
  }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___buttonTerminateProfile--rbh1r {
    border: 1px solid #fc3b60 !important;
    border-radius: 4px !important;
    background-color: transparent !important;
    box-shadow: none !important;
    min-width: 112px !important;
    font-size: 13px;
    color: #fc3b60 !important;
    letter-spacing: 0;
    text-align: center;
  }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteButtonContainer--yvLjD {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
  }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteProfileContainer--VCcTR {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    text-align: left;
  }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteProfileContainer--VCcTR .components-CompanyDetails-styles___deleteTextStyle--bqXlG {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 15px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-bottom: 5px;
    }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteProfileContainer--VCcTR .components-CompanyDetails-styles___deleteTextDescStyle--o7ttN {
      font-family: 'Roboto';
      font-size: 13px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 400;
    }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteProfileContainer--VCcTR .components-CompanyDetails-styles___bolder--IJYtv {
      font-weight: 600;
    }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___buttonCont--SHg7H button:first-child {
      margin-right: 10px;
    }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteButtonStyle--Uz6W2 {
    background: #fc3b60 !important;
    border-radius: 4px;
    font-family: 'Roboto';
    font-size: 13px !important;
    color: #ffffff !important;
    letter-spacing: 0;
    text-align: center;
  }

.components-CompanyDetails-styles___paperMax--pn760 {
  max-width: 1122px;
  margin: 0 0 30px;
}

.components-CompanyDetails-styles___loading--KzDKA {
  pointer-events: none;
}

.components-CompanyDetails-styles___inputContainer--UGNC7 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-CompanyDetails-styles___inputWrapper--O_cVV {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-CompanyDetails-styles___loginError--ookm6 {
  color: red;
  text-align: center;
  font-size: 12px;
  padding: 10px 0;
}

.components-CompanyDetails-styles___table--wZVQi {
  margin: 20px 0 0;
}

.components-CompanyDetails-styles___tableHead--rw5KN {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-CompanyDetails-styles___empTableHead--ISjvX {
  color: #1b2432 !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  padding-left: 16px !important;
  font-family: 'Roboto';
  white-space: nowrap;
}

.components-CompanyDetails-styles___empTableHead--ISjvX:first-child {
    text-align: left !important;
    padding-left: 0 !important;
  }

.components-CompanyDetails-styles___empListTableHead--tkuoI {
  padding-left: 8px !important;
}

.components-CompanyDetails-styles___cellHide--k4eZV {
  width: 20px;
  min-width: 0 !important;
  padding: 0 !important;
}

.components-CompanyDetails-styles___tableRow--t2fnI {
  height: 68px !important;
  cursor: pointer;
}

.components-CompanyDetails-styles___tableRow--t2fnI:last-child .components-CompanyDetails-styles___tableCell--_HyzY {
      border: none;
    }

.components-CompanyDetails-styles___tableRow--t2fnI:hover {
    background: #f6f6f7;
  }

.components-CompanyDetails-styles___tableRowEmp--DBe8z {
  vertical-align: top !important;
}

.components-CompanyDetails-styles___tableRowEmp--DBe8z .components-CompanyDetails-styles___name--jGmrC {
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
    display: block;
    margin-bottom: 2px;
    font-weight: bold;
  }

.components-CompanyDetails-styles___tableRowEmp--DBe8z .components-CompanyDetails-styles___details--BNzvg {
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
    display: block;
  }

.components-CompanyDetails-styles___tableRowEmp--DBe8z:last-child .components-CompanyDetails-styles___tableCellEmp--Y9Sk0 {
      border: none;
    }

.components-CompanyDetails-styles___tableRowEmp--DBe8z:last-child .components-CompanyDetails-styles___tableCellAvatar--LM_oG {
      max-width: 250px !important;
      border: none;
    }

.components-CompanyDetails-styles___tableRowEmp--DBe8z:last-child .components-CompanyDetails-styles___tableCellEmpList--Ma9ts {
      max-width: 250px !important;
      border: none;
    }

.components-CompanyDetails-styles___tableRowEmp--DBe8z td:first-child {
    border-bottom: none;
  }

.components-CompanyDetails-styles___tableRowEmp--DBe8z td:last-child {
    border-bottom: none;
  }

.components-CompanyDetails-styles___tableCell--_HyzY {
  font-size: 15px !important;
  padding: 16px 56px 16px 24px !important;
}

.components-CompanyDetails-styles___tableCellEmp--Y9Sk0 {
  font-size: 15px !important;
  padding: 16px 16px !important;
  max-width: 210px;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 100px !important;
}

.components-CompanyDetails-styles___tableCellEmp--Y9Sk0:first-child {
    text-align: left !important;
    padding-left: 0 !important;
  }

.components-CompanyDetails-styles___tableCellEmpList--Ma9ts {
  font-size: 15px !important;
  padding: 24px 8px !important;
  max-width: 240px;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 120px !important;
}

.components-CompanyDetails-styles___tableCellEmpList--Ma9ts:first-child {
    text-align: left !important;
    padding-left: 0 !important;
  }

.components-CompanyDetails-styles___tableCellAvatar--LM_oG {
  padding: 24px 16px !important;
  padding-left: 8px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 45px !important;
  margin: 0 !important;
  min-width: 45px !important;
  padding-right: 11px !important;
}

.components-CompanyDetails-styles___tableCellAvatarPaddingHead--C6RlC {
  padding: 14px 16px !important;
}

.components-CompanyDetails-styles___tableCellAvatarPaddingHead--C6RlC span {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

.components-CompanyDetails-styles___checkBox--s7LSK span {
    padding-top: 3px !important;
  }

.components-CompanyDetails-styles___buttonClick--NFI60 {
  text-align: right !important;
  padding-right: 0px !important;
}

.components-CompanyDetails-styles___emptyData--hS4c7 {
  padding: 24px 0;
}

.components-CompanyDetails-styles___employeesTitle--aUDEX {
  display: flex;
  margin-bottom: 32px;
  justify-content: flex-end;
}

.components-CompanyDetails-styles___employeesTitle--aUDEX h2 {
    font-weight: 600;
  }

.components-CompanyDetails-styles___addCompany--QJN6C {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #1e8aff !important;
  font-size: 13px;
  cursor: pointer;
}

.components-CompanyDetails-styles___addCompany--QJN6C:hover {
    color: #f6f6f7;
  }

.components-CompanyDetails-styles___addCompany--QJN6C {
  width: 100%;
}

.components-CompanyDetails-styles___addIcon--oZtkD {
  height: 18px;
  margin-right: 5px;
}

.components-CompanyDetails-styles___buttons--b_ijB {
  border-top: 1px solid #dddee0;
  padding: 32px 0;
  display: flex;
  justify-content: flex-end;
}

.components-CompanyDetails-styles___cancel--vWxHX {
  color: #6d717a;
  margin-right: 12px;
}

.components-CompanyDetails-styles___infoLoader--Amyic {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
}

.components-CompanyDetails-styles___isLoading--aTKXG {
  background: #f6f6f7;
  position: relative;
}

.components-CompanyDetails-styles___avatar--jYxPF {
  width: 32px !important;
  height: 32px !important;
}

.components-CompanyDetails-styles___avatarLetter--lWBoX {
  width: 32px !important;
  height: 32px !important;
  font-size: 19px !important;
  letter-spacing: 0;
  color: #ffffff !important;
  letter-spacing: 0 !important;
  text-align: center !important;
  background-color: #1b2432 !important;
  text-transform: uppercase !important;
}

.components-CompanyDetails-styles___tableEmp--Mi23B thead {
    box-shadow: 0px 21px 13px -14px rgba(109, 113, 122, 0.15) !important;
  }

.components-CompanyDetails-styles___tableEmp--Mi23B thead tr {
      border-bottom: 2px solid rgba(224, 224, 224, 1);
    }

.components-CompanyDetails-styles___tableEmp--Mi23B {
  margin: 0;
}

.components-CompanyDetails-styles___empTableBody--UhBzL {
  padding: 32px 32px 0;
}

.components-CompanyDetails-styles___importBox--O7_FE {
  border: 1px solid #318afb;
  border-radius: 6px;
  font-size: 17px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 85px;
  margin-right: 16px;
  cursor: pointer;
}

.components-CompanyDetails-styles___importBox--O7_FE:hover {
    background: #318afb;
    color: white;
  }

.components-CompanyDetails-styles___searchBox--B2TBe {
  background: #ffffff;
  border: 1px solid #e0e2e6;
  border-radius: 4px;
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  position: relative;
  width: 100%;
  width: 230px;
  height: 52px;
}

.components-CompanyDetails-styles___searchBox--B2TBe span {
    position: absolute;
    top: 17px;
    left: 7px;
    display: block;
  }

.components-CompanyDetails-styles___searchBox--B2TBe svg {
    margin-left: 3px;
  }

.components-CompanyDetails-styles___searchBox--B2TBe input {
  height: 52px;
  background: #ffffff;
  border: 1px solid #e0e2e6;
  left: 60px;
  width: 100%;
  border-radius: 4px;
  padding-left: 34px !important;
  font-size: 15px;
  color: #6d717a;
}

.components-CompanyDetails-styles___status_box--J99Ki {
  border: 1px solid #12da9f;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-weight: 600;
}

.components-CompanyDetails-styles___status_box--J99Ki span {
    padding: 6px;
  }

.components-CompanyDetails-styles___active--GluMs {
  background: rgba(18, 218, 159, 0.1);
  max-width: 53px;
}

.components-CompanyDetails-styles___invite_sent--mf6se {
  background: rgba(49, 138, 251, 0.1);
  border: 1px solid #318afb;
  max-width: 80px;
}

.components-CompanyDetails-styles___not_invited--bI7X2 {
  background: rgba(242, 106, 89, 0.1);
  border: 1px solid #f26a59;
  max-width: 80px;
}

.components-CompanyDetails-styles___checkBoxPadding--WaMDm {
  min-width: 0 !important;
  padding-left: 8px !important;
  padding-right: 1px !important;
  width: 40px !important;
}

.components-CompanyDetails-styles___checkBoxPadding--WaMDm span {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

.components-CompanyDetails-styles___emptyDataEmplist--GT5In {
  padding: 24px 30px;
}

.components-CompanyDetails-styles___dialogBox--dKjzb {
  min-width: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___title--JIWWm {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
    padding-bottom: 12px;
  }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___title--JIWWm .components-CompanyDetails-styles___closeIcon--EqaF8 {
      position: absolute;
      top: 18px;
      right: 18px;
    }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___title--JIWWm .components-CompanyDetails-styles___closeIcon--EqaF8 .components-CompanyDetails-styles___svg--PqFXn {
        font-size: 26px;
      }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___container--MLq_8 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 32px;
    margin-bottom: 0px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e0e2e6;
  }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___container--MLq_8 .components-CompanyDetails-styles___textField--m9jkH {
      margin: 18px 0 14px !important;
    }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___inputContainer--UGNC7 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    max-width: 636px;
    max-width: 700px;
    margin-top: 0px;
    margin-bottom: 0;
    padding-bottom: 0;
    font-family: 'Roboto';
  }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___inputWrapper--O_cVV {
    flex: 49% 0 1;
    padding: 0;
  }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___actionButtons--Y_NUc {
    display: flex;
    justify-content: flex-end;
    padding-top: 38px;
    padding-bottom: 31px;
    margin-top: 14px;
    border-top: 1px solid #e0e2e6;
    margin-left: 30px;
    margin-right: 30px;
  }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___actionButtons--Y_NUc button {
      width: 150px !important;
      height: 52px !important;
      font-size: 17px;
    }

.components-CompanyDetails-styles___dialogBox--dKjzb .components-CompanyDetails-styles___cancelButton--UjlhL {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-CompanyDetails-styles___checkBoxText--snuvQ {
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  cursor: pointer;
}

.components-CompanyDetails-styles___checkContainer--QAUHh {
  display: flex;
  flex-direction: row;
  margin-top: 18px;
  margin-bottom: 8px;
}

.components-CompanyDetails-styles___checkContainer--QAUHh span {
    padding-left: 0;
  }

.components-CompanyDetails-styles___loaderContainer--tV9VN {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-CompanyDetails-styles___inputWrapperPop--uKyF6 {
  flex: 48% 0 1;
  padding: 0;
}

.components-CompanyDetails-styles___editCell--VNCuN {
  min-width: 0 !important;
  padding-right: 0 !important;
}

.components-CompanyDetails-styles___editCell--VNCuN div {
    padding-top: 2px;
    text-align: end;
  }

.components-CompanyDetails-styles___imgAndTextContainer--ewpQW {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
}

.components-CompanyDetails-styles___imgAndTextContainerOnboard--upXRn {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  align-items: flex-start;
}

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI,
.components-CompanyDetails-styles___onboardingCompPaper--aqayf {
  padding: 33px 32px 30px 32px;
  padding-top: 0;
}

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___titleStyle--a3QTM, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___titleStyle--a3QTM {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    padding-top: 30px;
  }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___legdeImgContainer--k6Ikk, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___legdeImgContainer--k6Ikk {
    height: 34px;
  }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___legdeImgContainer--k6Ikk img, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___legdeImgContainer--k6Ikk img {
      width: 34px;
      height: 34px;
      border: 1px solid #dddee0;
      border-radius: 99px;
    }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___legdeTextContainer--NKeei, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___legdeTextContainer--NKeei {
    font-size: 21px;
    color: #6d717a;
    letter-spacing: 0;
    padding-left: 22px;
  }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___onboardingTextContainer--p2SlK, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___onboardingTextContainer--p2SlK {
    font-family: 'Roboto-Medium', 'Roboto';
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    padding-left: 10px;
  }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___expenseManagement--IBGzT .components-CompanyDetails-styles___expenseTextContainer--sYvr2, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___expenseManagement--IBGzT .components-CompanyDetails-styles___expenseTextContainer--sYvr2 {
      font-size: 21px;
      color: #6d717a;
      letter-spacing: 0;
      padding-left: 22px;
    }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___expenseManagement--IBGzT .components-CompanyDetails-styles___expenseTextContainer--sYvr2::first-letter, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___expenseManagement--IBGzT .components-CompanyDetails-styles___expenseTextContainer--sYvr2::first-letter {
      text-transform: uppercase;
    }

.components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI .components-CompanyDetails-styles___listExpenseManagement--YrZ6o, .components-CompanyDetails-styles___onboardingCompPaper--aqayf .components-CompanyDetails-styles___listExpenseManagement--YrZ6o {
    display: flex;
    flex-direction: column;
  }

.components-CompanyDetails-styles___agencySetting--Ja8kh {
  padding-bottom: 0;
}

.components-CompanyDetails-styles___agencySetting--Ja8kh h2 {
    margin-bottom: 10px;
    font-weight: 600 !important;
  }

.components-CompanyDetails-styles___tab--IqjLb {
  border-bottom: 1px solid #c6c8cc !important;
}

.components-CompanyDetails-styles___tab--IqjLb span {
    text-transform: none;
    font-size: 17px;
  }

.components-CompanyDetails-styles___tabs--DP7_w {
  margin-bottom: 6px !important;
}

.components-CompanyDetails-styles___inputContainerPop--yS4WR {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.components-CompanyDetails-styles___expenseManagementBorder--uiaDU {
  border-top: 1px solid #dddee0;
  margin-top: 30px;
}

.components-CompanyDetails-styles___companyInfoDescription--f01sc {
  text-align: left;
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  padding: 0 32px 15px 32px;
  font-family: 'Roboto';
  width: 700px;
}

.components-CompanyDetails-styles___popupButtonsContainer--TYWoe {
  text-align: right;
  margin-left: 32px;
  margin-right: 32px;
  padding: 32px 0;
  border-top: 1px solid #d8d8d8;
  margin-top: 28px;
}

.components-CompanyDetails-styles___compPopupButton--Ic_YK {
  background: #318afb;
  border-radius: 6px;
  font-family: 'Roboto';
  font-size: 17px;
  color: #ffffff;
  letter-spacing: 0;
  width: 200px;
  text-align: center;
  height: 52px;
}

.components-CompanyDetails-styles___companyInfoHeader--vv3Pl {
  display: flex;
}

.components-CompanyDetails-styles___companyInfoHeaderText--XvmG_ h2 {
  font-size: 21px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.components-CompanyDetails-styles___companyInfoHeaderText--XvmG_ .components-CompanyDetails-styles___description--VPtJy {
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-CompanyDetails-styles___companyInfoContainer--CQtr3 {
  border: 1px solid #dddee0;
  border-radius: 4px;
  padding-top: 25px;
  padding-bottom: 17px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 32px;
  margin-top: 18px;
}

.components-CompanyDetails-styles___companyInfoContainerRow--NuWO5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-CompanyDetails-styles___companyInfoHeaderText--XvmG_ {
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  margin-left: 22px;
}

.components-CompanyDetails-styles___companyInfoContainerDetails--lvMwD {
  display: flex;
  align-items: center;
  max-width: 600px;
  flex-wrap: wrap;
}

.components-CompanyDetails-styles___companyInfoContainerDetails--lvMwD p {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }

.components-CompanyDetails-styles___descr--I4p21 {
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
  line-height: 20px;
  display: flex;
  align-items: center;
  width: 255px;
}

.components-CompanyDetails-styles___descr--I4p21 p {
  color: #1b2432;
  letter-spacing: 0;
  padding-left: 5px;
}

.components-CompanyDetails-styles___buttonEdit--IZ_YV {
  width: 55px;
  min-width: 55px !important;
}

.components-CompanyDetails-styles___selectWrapper--wdO62 {
  width: 100%;
}

.components-CompanyDetails-styles___companyInfoHeaderIconContainer--mbawo {
  background: #1b2432;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.components-CompanyDetails-styles___paginationContainer--jwmEP {
  display: flex;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e0e2e6;
  border-radius: 4px;
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
  max-width: -moz-fit-content;
  max-width: fit-content;
  align-items: center;
  margin: auto;
}

.components-CompanyDetails-styles___buttonPaginationPrev--xFvk_ {
  border-right: 1px solid #e0e2e6;
  height: 32px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.components-CompanyDetails-styles___buttonPaginationPrev--xFvk_ svg {
  transform: rotate(-180deg);
}

.components-CompanyDetails-styles___buttonPagination--c9GeD {
  height: 32px;
  width: 25px;
  border-left: 1px solid #e0e2e6;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.components-CompanyDetails-styles___numberHolder--X0Vmn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 32px;
}

.components-CompanyDetails-styles___paginationPageCont--mjr76 {
  width: 100%;
  align-items: center;
}

.components-CompanyDetails-styles___informationTitleCompany--XSbrC {
  margin-left: 32px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.components-CompanyDetails-styles___companyInfoAddress--G0Vv0 {
  margin-top: 3px;
}

.components-CompanyDetails-styles___companyInfoAddress--G0Vv0 .components-CompanyDetails-styles___descr--I4p21 {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.components-CompanyDetails-styles___companyInfoAddress--G0Vv0 .components-CompanyDetails-styles___descr--I4p21 div {
  display: flex;
  line-height: 11px;
}

.components-CompanyDetails-styles___companyInfoAddress--G0Vv0 .components-CompanyDetails-styles___descr--I4p21 div:empty {
  display: none;
}

.components-CompanyDetails-styles___companyInfoAddress--G0Vv0 .components-CompanyDetails-styles___descr--I4p21 .components-CompanyDetails-styles___infCont--GGhjI {
  flex-direction: column;
}

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___cancelButton--UjlhL {
    border: 1px solid #318afb;
    border-radius: 4px;
    font-size: 13px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    width: 93px;
  }

.components-CompanyDetails-styles___statusUpdate--ZAjkP .components-CompanyDetails-styles___deleteButtonStyle--Uz6W2 {
    width: 93px;
  }

.components-CompanyDetails-styles___companyEmployeePopup--wuER6 .components-CompanyDetails-styles___button--lVINt:disabled {
  background-color: #318afb !important;
  opacity: 20% !important;
  color: white;
}

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF div {
  border: none !important;
  border-bottom-color: none !important;
}

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF {
  margin-top: 0px !important;
  border: none !important;
  border-radius: 6px;
  font-size: 17px;
  color: #318afb;
  margin-right: 15px !important;
  width: 78px;
}

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF fieldset {
    border: 1px solid #318afb !important;
  }

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF div,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF svg,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF label {
    color: #318afb !important;
    font-size: 17px;
  }

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:hover {
  background: #318afb;
  color: white;
}

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:hover div,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:hover svg,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:hover label {
    color: white !important;
  }

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:hover fieldset {
    border: 1px solid #318afb !important;
  }

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:active {
  background: #318afb;
  color: white;
}

.components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:active div,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:active svg,
  .components-CompanyDetails-styles___selectWrapperEmpl--EtHAF:active label {
    color: white !important;
  }

.components-CompanyDetails-styles___confirmationDialog--cVi9H .components-CompanyDetails-styles___title--JIWWm {
    font-size: 19px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 0 0;
  }

.components-CompanyDetails-styles___confirmationDialog--cVi9H .components-CompanyDetails-styles___title--JIWWm.components-CompanyDetails-styles___bookingErrorPopupTitle--Exfz1 {
      min-width: 400px;
    }

.components-CompanyDetails-styles___confirmationDialog--cVi9H .components-CompanyDetails-styles___body--vFDL1 {
    color: #6d717a;
    font-size: 15px;
    padding: 36px;
    padding-top: 15px;
    max-width: 450px;
  }

.components-CompanyDetails-styles___confirmationDialog--cVi9H .components-CompanyDetails-styles___confBody--k0n6Q {
    color: #6d717a;
    font-size: 15px;
    padding: 36px;
    padding-top: 15px;
    max-width: 450px;
  }

.components-CompanyDetails-styles___confirmationPopupButtons--nC27x {
  padding: 32px;
  padding-top: 0px;
  margin: 0 !important;

  display: flex;
  justify-content: center;
}

.components-CompanyDetails-styles___confirmationPopupButtons--nC27x button {
    width: 185px !important;
    height: 52px;
    font-size: 17px;
  }

.components-CompanyDetails-styles___confirmationPopupButtons--nC27x button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-CompanyDetails-styles___confirmationPopupButtons--nC27x .components-CompanyDetails-styles___cancelButton--UjlhL {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    background-color: white;
    letter-spacing: 0;
    text-align: center;
    color: 318AFB;
  }

.components-CompanyDetails-styles___infoLoaderDep--zrkvd {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -18px;
  right: 0;
}

.components-CompanyDetails-styles___headerFilterBorder--w5DnR {
  border: 1px solid #e0e2e6;
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.components-CompanyDetails-styles___headerFilterBorder--w5DnR:hover {
  border: 1px solid #318afb;
}

.components-CompanyDetails-styles___headerFilterBorderActive--RjsEh {
  border: 1px solid #318afb;
}

.components-CompanyDetails-styles___inputWrapperPopup--wbDHF {
  min-height: unset !important;
}

.components-CompanyDetails-styles___prevSelectedText--cc1Yb {
  font-size: 1rem;
  color: #6d717a;
  font-weight: 500;
  text-align: left;
  margin-left: 20px;
  margin-right: 20px;
}

.components-CompanyDetails-styles___lineBefore--ygJC8 {
  border-top: 1px solid #c6c8cc;
  margin-left: 20px;
  margin-right: 20px;
}

.components-CompanyDetails-styles___dropdownContainer--QXHXM ul {
    width: 307px;
  }

.components-CompanyDetails-styles___dropdownContainer--QXHXM div[role='listbox'] {
    max-height: 230px;
    overflow-y: auto;
  }
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAmE7B;;AAjEE;IACE,sBAAsB;EACxB;;AAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,mBAAmB;IACnB,aAAa;IACb,2BAA2B;EAC7B;;AAEA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAsBlB;;AApBE;MACE,qBAAqB;MACrB,gBAAgB;MAChB,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,qBAAqB;MACrB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;AAEA;MACE,gBAAgB;IAClB;;AAIA;MACE,kBAAkB;IACpB;;AAGF;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;AAGF;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AAMrB;;AAJE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;AAGF;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AAWjB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAEF;EACE,8BAA8B;AAsChC;;AApCE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;AAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB;;AAGE;MACE,YAAY;IACd;;AACA;MACE,2BAA2B;MAC3B,YAAY;IACd;;AACA;MACE,2BAA2B;MAC3B,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AACA;IACE,mBAAmB;EACrB;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAM7B;;AAJE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;AAGF;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAM7B;;AAJE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;AAGF;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAM/B;;AAJE;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;AAIA;IACE,2BAA2B;EAC7B;;AAGF;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAK3B;;AAHE;IACE,gBAAgB;EAClB;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;AAKjB;;AAJE;IACE,cAAc;EAChB;;ACtRF;EDuRE;CCvRF;;ADyRA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;AACtC;;AAGE;IACE,oEAAoE;EAKtE;;AAHE;MACE,+CAA+C;IACjD;;ACjVJ;EDmVE;CCnVF;;ADsVA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AAKjB;;AAJE;IACE,mBAAmB;IACnB,YAAY;EACd;;AAGF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AAYd;;AAVE;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;EAChB;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAKlB;;AAHE;IACE,YAAY;EACd;;AAGF;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AAKxB;;AAJE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAkFzB;;AAhFE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,oBAAoB;EAWtB;;AATE;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;IAKb;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;EAKlC;;AAHE;MACE,8BAA8B;IAChC;;AAGF;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;AAEA;IACE,aAAa;IACb,UAAU;EACZ;;AAEA;IACE,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;EAOpB;;AALE;MACE,uBAAuB;MACvB,uBAAuB;MACvB,eAAe;IACjB;;AAEF;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AAKpB;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAK7B;;AAJE;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAiDhB;;AA/CE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;AAEA;IACE,YAAY;EAOd;;AANE;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,mBAAmB;IACrB;;AAGF;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,sCAAsC;IACtC,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;AAGE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AACA;MACE,yBAAyB;IAC3B;;AAEF;IACE,aAAa;IACb,sBAAsB;EACxB;;AAGF;EACE,iBAAiB;AAMnB;;AAJE;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;AAGF;EACE,2CAA2C;AAK7C;;AAJE;IACE,oBAAoB;IACpB,eAAe;EACjB;;AAEF;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AAMjB;;AAJE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;AAGF;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAAsB;EAAtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAGE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;AAEA;IACE,WAAW;EACb;;AAGF;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,WAAW;AAYb;;AAVE;IACE,oCAAoC;EACtC;;AAEA;;;IAGE,yBAAyB;IACzB,eAAe;EACjB;;AAGF;EACE,mBAAmB;EACnB,YAAY;AAWd;;AATE;;;IAGE,uBAAuB;EACzB;;AAEA;IACE,oCAAoC;EACtC;;AAGF;EACE,mBAAmB;EACnB,YAAY;AAOd;;AALE;;;IAGE,uBAAuB;EACzB;;AAIA;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EAKnB;;AAHE;MACE,gBAAgB;IAClB;;AAGF;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;;EAEpB,aAAa;EACb,uBAAuB;AA0BzB;;AAzBE;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAGE;IACE,YAAY;EACd;;AAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB","sourcesContent":[".paper {\n  padding: 32px 32px 0;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.statusUpdate {\n  padding: 17px 30px 0px 30px;\n\n  .button {\n    width: 93px !important;\n  }\n\n  .buttonTerminateProfile {\n    border: 1px solid #fc3b60 !important;\n    border-radius: 4px !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    min-width: 112px !important;\n    font-size: 13px;\n    color: #fc3b60 !important;\n    letter-spacing: 0;\n    text-align: center;\n  }\n\n  .deleteButtonContainer {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  .deleteProfileContainer {\n    margin-bottom: 30px;\n    display: flex;\n    justify-content: space-between;\n    text-align: left;\n\n    .deleteTextStyle {\n      font-family: 'Roboto';\n      font-weight: 500;\n      font-size: 15px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-bottom: 5px;\n    }\n\n    .deleteTextDescStyle {\n      font-family: 'Roboto';\n      font-size: 13px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 400;\n    }\n\n    .bolder {\n      font-weight: 600;\n    }\n  }\n\n  .buttonCont {\n    button:first-child {\n      margin-right: 10px;\n    }\n  }\n\n  .deleteButtonStyle {\n    background: #fc3b60 !important;\n    border-radius: 4px;\n    font-family: 'Roboto';\n    font-size: 13px !important;\n    color: #ffffff !important;\n    letter-spacing: 0;\n    text-align: center;\n  }\n}\n\n.paperMax {\n  max-width: 1122px;\n  margin: 0 0 30px;\n}\n\n.loading {\n  pointer-events: none;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.loginError {\n  color: red;\n  text-align: center;\n  font-size: 12px;\n  padding: 10px 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.empTableHead {\n  color: #1b2432 !important;\n  font-weight: 600 !important;\n  font-size: 15px !important;\n  padding-left: 16px !important;\n  font-family: 'Roboto';\n  white-space: nowrap;\n\n  &:first-child {\n    text-align: left !important;\n    padding-left: 0 !important;\n  }\n}\n\n.empListTableHead {\n  padding-left: 8px !important;\n}\n\n.cellHide {\n  width: 20px;\n  min-width: 0 !important;\n  padding: 0 !important;\n}\n\n.tableRow {\n  height: 68px !important;\n  cursor: pointer;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n.tableRowEmp {\n  vertical-align: top !important;\n\n  .name {\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n    display: block;\n    margin-bottom: 2px;\n    font-weight: bold;\n  }\n\n  .details {\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n    display: block;\n  }\n\n  &:last-child {\n    .tableCellEmp {\n      border: none;\n    }\n    .tableCellAvatar {\n      max-width: 250px !important;\n      border: none;\n    }\n    .tableCellEmpList {\n      max-width: 250px !important;\n      border: none;\n    }\n  }\n\n  td:first-child {\n    border-bottom: none;\n  }\n  td:last-child {\n    border-bottom: none;\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 56px 16px 24px !important;\n}\n\n.tableCellEmp {\n  font-size: 15px !important;\n  padding: 16px 16px !important;\n  max-width: 210px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  min-width: 100px !important;\n\n  &:first-child {\n    text-align: left !important;\n    padding-left: 0 !important;\n  }\n}\n\n.tableCellEmpList {\n  font-size: 15px !important;\n  padding: 24px 8px !important;\n  max-width: 240px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  min-width: 120px !important;\n\n  &:first-child {\n    text-align: left !important;\n    padding-left: 0 !important;\n  }\n}\n\n.tableCellAvatar {\n  padding: 24px 16px !important;\n  padding-left: 8px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 45px !important;\n  margin: 0 !important;\n  min-width: 45px !important;\n  padding-right: 11px !important;\n}\n\n.tableCellAvatarPaddingHead {\n  padding: 14px 16px !important;\n\n  span {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n}\n\n.checkBox {\n  span {\n    padding-top: 3px !important;\n  }\n}\n\n.buttonClick {\n  text-align: right !important;\n  padding-right: 0px !important;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n.employeesTitle {\n  display: flex;\n  margin-bottom: 32px;\n  justify-content: flex-end;\n\n  h2 {\n    font-weight: 600;\n  }\n}\n.addCompany {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  color: #1e8aff !important;\n  font-size: 13px;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n  width: 100%;\n}\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.buttons {\n  border-top: 1px solid #dddee0;\n  padding: 32px 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cancel {\n  color: #6d717a;\n  margin-right: 12px;\n}\n\n.infoLoader {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n}\n\n.isLoading {\n  background: #f6f6f7;\n  position: relative;\n}\n\n.avatar {\n  width: 32px !important;\n  height: 32px !important;\n}\n\n.avatarLetter {\n  width: 32px !important;\n  height: 32px !important;\n  font-size: 19px !important;\n  letter-spacing: 0;\n  color: #ffffff !important;\n  letter-spacing: 0 !important;\n  text-align: center !important;\n  background-color: #1b2432 !important;\n  text-transform: uppercase !important;\n}\n\n.tableEmp {\n  thead {\n    box-shadow: 0px 21px 13px -14px rgba(109, 113, 122, 0.15) !important;\n\n    tr {\n      border-bottom: 2px solid rgba(224, 224, 224, 1);\n    }\n  }\n  margin: 0;\n}\n\n.empTableBody {\n  padding: 32px 32px 0;\n}\n\n.importBox {\n  border: 1px solid #318afb;\n  border-radius: 6px;\n  font-size: 17px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 52px;\n  width: 85px;\n  margin-right: 16px;\n  cursor: pointer;\n  &:hover {\n    background: #318afb;\n    color: white;\n  }\n}\n\n.searchBox {\n  background: #ffffff;\n  border: 1px solid #e0e2e6;\n  border-radius: 4px;\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  position: relative;\n  width: 100%;\n  width: 230px;\n  height: 52px;\n\n  span {\n    position: absolute;\n    top: 17px;\n    left: 7px;\n    display: block;\n  }\n\n  svg {\n    margin-left: 3px;\n  }\n}\n\n.searchBox input {\n  height: 52px;\n  background: #ffffff;\n  border: 1px solid #e0e2e6;\n  left: 60px;\n  width: 100%;\n  border-radius: 4px;\n  padding-left: 34px !important;\n  font-size: 15px;\n  color: #6d717a;\n}\n\n.status_box {\n  border: 1px solid #12da9f;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto';\n  font-weight: 600;\n\n  span {\n    padding: 6px;\n  }\n}\n\n.active {\n  background: rgba(18, 218, 159, 0.1);\n  max-width: 53px;\n}\n\n.invite_sent {\n  background: rgba(49, 138, 251, 0.1);\n  border: 1px solid #318afb;\n  max-width: 80px;\n}\n\n.not_invited {\n  background: rgba(242, 106, 89, 0.1);\n  border: 1px solid #f26a59;\n  max-width: 80px;\n}\n\n.checkBoxPadding {\n  min-width: 0 !important;\n  padding-left: 8px !important;\n  padding-right: 1px !important;\n  width: 40px !important;\n  span {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n.emptyDataEmplist {\n  padding: 24px 30px;\n}\n\n.dialogBox {\n  min-width: 700px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n    padding-bottom: 12px;\n\n    .closeIcon {\n      position: absolute;\n      top: 18px;\n      right: 18px;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 32px;\n    margin-bottom: 0px;\n    padding-bottom: 32px;\n    border-bottom: 1px solid #e0e2e6;\n\n    .textField {\n      margin: 18px 0 14px !important;\n    }\n  }\n\n  .inputContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-left: 30px;\n    padding-right: 30px;\n    max-width: 636px;\n    max-width: 700px;\n    margin-top: 0px;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    font-family: 'Roboto';\n  }\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 0;\n  }\n\n  .actionButtons {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 38px;\n    padding-bottom: 31px;\n    margin-top: 14px;\n    border-top: 1px solid #e0e2e6;\n    margin-left: 30px;\n    margin-right: 30px;\n\n    button {\n      width: 150px !important;\n      height: 52px !important;\n      font-size: 17px;\n    }\n  }\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.checkBoxText {\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n\n.checkContainer {\n  display: flex;\n  flex-direction: row;\n  margin-top: 18px;\n  margin-bottom: 8px;\n\n  span {\n    padding-left: 0;\n  }\n}\n\n.loaderContainer {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.inputWrapperPop {\n  flex: 48% 0 1;\n  padding: 0;\n}\n\n.editCell {\n  min-width: 0 !important;\n  padding-right: 0 !important;\n  div {\n    padding-top: 2px;\n    text-align: end;\n  }\n}\n\n.imgAndTextContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.imgAndTextContainerOnboard {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n  align-items: flex-start;\n}\n\n.activeExpenseIntegrationPaper,\n.onboardingCompPaper {\n  padding: 33px 32px 30px 32px;\n  padding-top: 0;\n\n  .titleStyle {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    padding-top: 30px;\n  }\n\n  .legdeImgContainer {\n    height: 34px;\n    img {\n      width: 34px;\n      height: 34px;\n      border: 1px solid #dddee0;\n      border-radius: 99px;\n    }\n  }\n\n  .legdeTextContainer {\n    font-size: 21px;\n    color: #6d717a;\n    letter-spacing: 0;\n    padding-left: 22px;\n  }\n\n  .onboardingTextContainer {\n    font-family: 'Roboto-Medium', 'Roboto';\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    padding-left: 10px;\n  }\n\n  .expenseManagement {\n    .expenseTextContainer {\n      font-size: 21px;\n      color: #6d717a;\n      letter-spacing: 0;\n      padding-left: 22px;\n    }\n    .expenseTextContainer::first-letter {\n      text-transform: uppercase;\n    }\n  }\n  .listExpenseManagement {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.agencySetting {\n  padding-bottom: 0;\n\n  h2 {\n    margin-bottom: 10px;\n    font-weight: 600 !important;\n  }\n}\n\n.tab {\n  border-bottom: 1px solid #c6c8cc !important;\n  span {\n    text-transform: none;\n    font-size: 17px;\n  }\n}\n.tabs {\n  margin-bottom: 6px !important;\n}\n\n.inputContainerPop {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.expenseManagementBorder {\n  border-top: 1px solid #dddee0;\n  margin-top: 30px;\n}\n\n.companyInfoDescription {\n  text-align: left;\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  padding: 0 32px 15px 32px;\n  font-family: 'Roboto';\n  width: 700px;\n}\n\n.popupButtonsContainer {\n  text-align: right;\n  margin-left: 32px;\n  margin-right: 32px;\n  padding: 32px 0;\n  border-top: 1px solid #d8d8d8;\n  margin-top: 28px;\n}\n\n.compPopupButton {\n  background: #318afb;\n  border-radius: 6px;\n  font-family: 'Roboto';\n  font-size: 17px;\n  color: #ffffff;\n  letter-spacing: 0;\n  width: 200px;\n  text-align: center;\n  height: 52px;\n}\n\n.companyInfoHeader {\n  display: flex;\n}\n\n.companyInfoHeaderText h2 {\n  font-size: 21px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 5px;\n}\n\n.companyInfoHeaderText .description {\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.companyInfoContainer {\n  border: 1px solid #dddee0;\n  border-radius: 4px;\n  padding-top: 25px;\n  padding-bottom: 17px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 32px;\n  margin-top: 18px;\n}\n\n.companyInfoContainerRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.companyInfoHeaderText {\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-left: 22px;\n}\n.companyInfoContainerDetails {\n  display: flex;\n  align-items: center;\n  max-width: 600px;\n  flex-wrap: wrap;\n\n  p {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n}\n\n.descr {\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  width: 255px;\n}\n\n.descr p {\n  color: #1b2432;\n  letter-spacing: 0;\n  padding-left: 5px;\n}\n\n.buttonEdit {\n  width: 55px;\n  min-width: 55px !important;\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n.companyInfoHeaderIconContainer {\n  background: #1b2432;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.paginationContainer {\n  display: flex;\n  height: 32px;\n  background: #ffffff;\n  border: 1px solid #e0e2e6;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n  max-width: fit-content;\n  align-items: center;\n  margin: auto;\n}\n\n.buttonPaginationPrev {\n  border-right: 1px solid #e0e2e6;\n  height: 32px;\n  width: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.buttonPaginationPrev svg {\n  transform: rotate(-180deg);\n}\n\n.buttonPagination {\n  height: 32px;\n  width: 25px;\n  border-left: 1px solid #e0e2e6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.numberHolder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 64px;\n  height: 32px;\n}\n\n.paginationPageCont {\n  width: 100%;\n  align-items: center;\n}\n\n.informationTitleCompany {\n  margin-left: 32px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.companyInfoAddress {\n  margin-top: 3px;\n}\n\n.companyInfoAddress .descr {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n.companyInfoAddress .descr div {\n  display: flex;\n  line-height: 11px;\n}\n\n.companyInfoAddress .descr div:empty {\n  display: none;\n}\n\n.companyInfoAddress .descr .infCont {\n  flex-direction: column;\n}\n\n.statusUpdate {\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 4px;\n    font-size: 13px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    width: 93px;\n  }\n\n  .deleteButtonStyle {\n    width: 93px;\n  }\n}\n\n.companyEmployeePopup .button:disabled {\n  background-color: #318afb !important;\n  opacity: 20% !important;\n  color: white;\n}\n\n.selectWrapperEmpl div {\n  border: none !important;\n  border-bottom-color: none !important;\n}\n\n.selectWrapperEmpl {\n  margin-top: 0px !important;\n  border: none !important;\n  border-radius: 6px;\n  font-size: 17px;\n  color: #318afb;\n  margin-right: 15px !important;\n  width: 78px;\n\n  fieldset {\n    border: 1px solid #318afb !important;\n  }\n\n  div,\n  svg,\n  label {\n    color: #318afb !important;\n    font-size: 17px;\n  }\n}\n\n.selectWrapperEmpl:hover {\n  background: #318afb;\n  color: white;\n\n  div,\n  svg,\n  label {\n    color: white !important;\n  }\n\n  fieldset {\n    border: 1px solid #318afb !important;\n  }\n}\n\n.selectWrapperEmpl:active {\n  background: #318afb;\n  color: white;\n\n  div,\n  svg,\n  label {\n    color: white !important;\n  }\n}\n\n.confirmationDialog {\n  .title {\n    font-size: 19px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 0 0;\n\n    &.bookingErrorPopupTitle {\n      min-width: 400px;\n    }\n  }\n\n  .body {\n    color: #6d717a;\n    font-size: 15px;\n    padding: 36px;\n    padding-top: 15px;\n    max-width: 450px;\n  }\n\n  .confBody {\n    color: #6d717a;\n    font-size: 15px;\n    padding: 36px;\n    padding-top: 15px;\n    max-width: 450px;\n  }\n}\n\n.confirmationPopupButtons {\n  padding: 32px;\n  padding-top: 0px;\n  margin: 0 !important;\n\n  display: flex;\n  justify-content: center;\n  button {\n    width: 185px !important;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    background-color: white;\n    letter-spacing: 0;\n    text-align: center;\n    color: 318AFB;\n  }\n}\n\n.infoLoaderDep {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: -18px;\n  right: 0;\n}\n\n.headerFilterBorder {\n  border: 1px solid #e0e2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 10px;\n  width: fit-content;\n}\n\n.headerFilterBorder:hover {\n  border: 1px solid #318afb;\n}\n\n.headerFilterBorderActive {\n  border: 1px solid #318afb;\n}\n\n.inputWrapperPopup {\n  min-height: unset !important;\n}\n\n.prevSelectedText {\n  font-size: 1rem;\n  color: #6d717a;\n  font-weight: 500;\n  text-align: left;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.lineBefore {\n  border-top: 1px solid #c6c8cc;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.dropdownContainer {\n  ul {\n    width: 307px;\n  }\n\n  div[role='listbox'] {\n    max-height: 230px;\n    overflow-y: auto;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-styles___paper--qqk6g`,
	"statusUpdate": `components-CompanyDetails-styles___statusUpdate--ZAjkP`,
	"button": `components-CompanyDetails-styles___button--lVINt`,
	"buttonTerminateProfile": `components-CompanyDetails-styles___buttonTerminateProfile--rbh1r`,
	"deleteButtonContainer": `components-CompanyDetails-styles___deleteButtonContainer--yvLjD`,
	"deleteProfileContainer": `components-CompanyDetails-styles___deleteProfileContainer--VCcTR`,
	"deleteTextStyle": `components-CompanyDetails-styles___deleteTextStyle--bqXlG`,
	"deleteTextDescStyle": `components-CompanyDetails-styles___deleteTextDescStyle--o7ttN`,
	"bolder": `components-CompanyDetails-styles___bolder--IJYtv`,
	"buttonCont": `components-CompanyDetails-styles___buttonCont--SHg7H`,
	"deleteButtonStyle": `components-CompanyDetails-styles___deleteButtonStyle--Uz6W2`,
	"paperMax": `components-CompanyDetails-styles___paperMax--pn760`,
	"loading": `components-CompanyDetails-styles___loading--KzDKA`,
	"inputContainer": `components-CompanyDetails-styles___inputContainer--UGNC7`,
	"inputWrapper": `components-CompanyDetails-styles___inputWrapper--O_cVV`,
	"loginError": `components-CompanyDetails-styles___loginError--ookm6`,
	"table": `components-CompanyDetails-styles___table--wZVQi`,
	"tableHead": `components-CompanyDetails-styles___tableHead--rw5KN`,
	"empTableHead": `components-CompanyDetails-styles___empTableHead--ISjvX`,
	"empListTableHead": `components-CompanyDetails-styles___empListTableHead--tkuoI`,
	"cellHide": `components-CompanyDetails-styles___cellHide--k4eZV`,
	"tableRow": `components-CompanyDetails-styles___tableRow--t2fnI`,
	"tableCell": `components-CompanyDetails-styles___tableCell--_HyzY`,
	"tableRowEmp": `components-CompanyDetails-styles___tableRowEmp--DBe8z`,
	"name": `components-CompanyDetails-styles___name--jGmrC`,
	"details": `components-CompanyDetails-styles___details--BNzvg`,
	"tableCellEmp": `components-CompanyDetails-styles___tableCellEmp--Y9Sk0`,
	"tableCellAvatar": `components-CompanyDetails-styles___tableCellAvatar--LM_oG`,
	"tableCellEmpList": `components-CompanyDetails-styles___tableCellEmpList--Ma9ts`,
	"tableCellAvatarPaddingHead": `components-CompanyDetails-styles___tableCellAvatarPaddingHead--C6RlC`,
	"checkBox": `components-CompanyDetails-styles___checkBox--s7LSK`,
	"buttonClick": `components-CompanyDetails-styles___buttonClick--NFI60`,
	"emptyData": `components-CompanyDetails-styles___emptyData--hS4c7`,
	"employeesTitle": `components-CompanyDetails-styles___employeesTitle--aUDEX`,
	"addCompany": `components-CompanyDetails-styles___addCompany--QJN6C`,
	"addIcon": `components-CompanyDetails-styles___addIcon--oZtkD`,
	"buttons": `components-CompanyDetails-styles___buttons--b_ijB`,
	"cancel": `components-CompanyDetails-styles___cancel--vWxHX`,
	"infoLoader": `components-CompanyDetails-styles___infoLoader--Amyic`,
	"isLoading": `components-CompanyDetails-styles___isLoading--aTKXG`,
	"avatar": `components-CompanyDetails-styles___avatar--jYxPF`,
	"avatarLetter": `components-CompanyDetails-styles___avatarLetter--lWBoX`,
	"tableEmp": `components-CompanyDetails-styles___tableEmp--Mi23B`,
	"empTableBody": `components-CompanyDetails-styles___empTableBody--UhBzL`,
	"importBox": `components-CompanyDetails-styles___importBox--O7_FE`,
	"searchBox": `components-CompanyDetails-styles___searchBox--B2TBe`,
	"statusBox": `components-CompanyDetails-styles___status_box--J99Ki`,
	"active": `components-CompanyDetails-styles___active--GluMs`,
	"inviteSent": `components-CompanyDetails-styles___invite_sent--mf6se`,
	"notInvited": `components-CompanyDetails-styles___not_invited--bI7X2`,
	"checkBoxPadding": `components-CompanyDetails-styles___checkBoxPadding--WaMDm`,
	"emptyDataEmplist": `components-CompanyDetails-styles___emptyDataEmplist--GT5In`,
	"dialogBox": `components-CompanyDetails-styles___dialogBox--dKjzb`,
	"title": `components-CompanyDetails-styles___title--JIWWm`,
	"closeIcon": `components-CompanyDetails-styles___closeIcon--EqaF8`,
	"svg": `components-CompanyDetails-styles___svg--PqFXn`,
	"container": `components-CompanyDetails-styles___container--MLq_8`,
	"textField": `components-CompanyDetails-styles___textField--m9jkH`,
	"actionButtons": `components-CompanyDetails-styles___actionButtons--Y_NUc`,
	"cancelButton": `components-CompanyDetails-styles___cancelButton--UjlhL`,
	"checkBoxText": `components-CompanyDetails-styles___checkBoxText--snuvQ`,
	"checkContainer": `components-CompanyDetails-styles___checkContainer--QAUHh`,
	"loaderContainer": `components-CompanyDetails-styles___loaderContainer--tV9VN`,
	"inputWrapperPop": `components-CompanyDetails-styles___inputWrapperPop--uKyF6`,
	"editCell": `components-CompanyDetails-styles___editCell--VNCuN`,
	"imgAndTextContainer": `components-CompanyDetails-styles___imgAndTextContainer--ewpQW`,
	"imgAndTextContainerOnboard": `components-CompanyDetails-styles___imgAndTextContainerOnboard--upXRn`,
	"activeExpenseIntegrationPaper": `components-CompanyDetails-styles___activeExpenseIntegrationPaper--j36sI`,
	"onboardingCompPaper": `components-CompanyDetails-styles___onboardingCompPaper--aqayf`,
	"titleStyle": `components-CompanyDetails-styles___titleStyle--a3QTM`,
	"legdeImgContainer": `components-CompanyDetails-styles___legdeImgContainer--k6Ikk`,
	"legdeTextContainer": `components-CompanyDetails-styles___legdeTextContainer--NKeei`,
	"onboardingTextContainer": `components-CompanyDetails-styles___onboardingTextContainer--p2SlK`,
	"expenseManagement": `components-CompanyDetails-styles___expenseManagement--IBGzT`,
	"expenseTextContainer": `components-CompanyDetails-styles___expenseTextContainer--sYvr2`,
	"listExpenseManagement": `components-CompanyDetails-styles___listExpenseManagement--YrZ6o`,
	"agencySetting": `components-CompanyDetails-styles___agencySetting--Ja8kh`,
	"tab": `components-CompanyDetails-styles___tab--IqjLb`,
	"tabs": `components-CompanyDetails-styles___tabs--DP7_w`,
	"inputContainerPop": `components-CompanyDetails-styles___inputContainerPop--yS4WR`,
	"expenseManagementBorder": `components-CompanyDetails-styles___expenseManagementBorder--uiaDU`,
	"companyInfoDescription": `components-CompanyDetails-styles___companyInfoDescription--f01sc`,
	"popupButtonsContainer": `components-CompanyDetails-styles___popupButtonsContainer--TYWoe`,
	"compPopupButton": `components-CompanyDetails-styles___compPopupButton--Ic_YK`,
	"companyInfoHeader": `components-CompanyDetails-styles___companyInfoHeader--vv3Pl`,
	"companyInfoHeaderText": `components-CompanyDetails-styles___companyInfoHeaderText--XvmG_`,
	"description": `components-CompanyDetails-styles___description--VPtJy`,
	"companyInfoContainer": `components-CompanyDetails-styles___companyInfoContainer--CQtr3`,
	"companyInfoContainerRow": `components-CompanyDetails-styles___companyInfoContainerRow--NuWO5`,
	"companyInfoContainerDetails": `components-CompanyDetails-styles___companyInfoContainerDetails--lvMwD`,
	"descr": `components-CompanyDetails-styles___descr--I4p21`,
	"buttonEdit": `components-CompanyDetails-styles___buttonEdit--IZ_YV`,
	"selectWrapper": `components-CompanyDetails-styles___selectWrapper--wdO62`,
	"companyInfoHeaderIconContainer": `components-CompanyDetails-styles___companyInfoHeaderIconContainer--mbawo`,
	"paginationContainer": `components-CompanyDetails-styles___paginationContainer--jwmEP`,
	"buttonPaginationPrev": `components-CompanyDetails-styles___buttonPaginationPrev--xFvk_`,
	"buttonPagination": `components-CompanyDetails-styles___buttonPagination--c9GeD`,
	"numberHolder": `components-CompanyDetails-styles___numberHolder--X0Vmn`,
	"paginationPageCont": `components-CompanyDetails-styles___paginationPageCont--mjr76`,
	"informationTitleCompany": `components-CompanyDetails-styles___informationTitleCompany--XSbrC`,
	"companyInfoAddress": `components-CompanyDetails-styles___companyInfoAddress--G0Vv0`,
	"infCont": `components-CompanyDetails-styles___infCont--GGhjI`,
	"companyEmployeePopup": `components-CompanyDetails-styles___companyEmployeePopup--wuER6`,
	"selectWrapperEmpl": `components-CompanyDetails-styles___selectWrapperEmpl--EtHAF`,
	"confirmationDialog": `components-CompanyDetails-styles___confirmationDialog--cVi9H`,
	"bookingErrorPopupTitle": `components-CompanyDetails-styles___bookingErrorPopupTitle--Exfz1`,
	"body": `components-CompanyDetails-styles___body--vFDL1`,
	"confBody": `components-CompanyDetails-styles___confBody--k0n6Q`,
	"confirmationPopupButtons": `components-CompanyDetails-styles___confirmationPopupButtons--nC27x`,
	"infoLoaderDep": `components-CompanyDetails-styles___infoLoaderDep--zrkvd`,
	"headerFilterBorder": `components-CompanyDetails-styles___headerFilterBorder--w5DnR`,
	"headerFilterBorderActive": `components-CompanyDetails-styles___headerFilterBorderActive--RjsEh`,
	"inputWrapperPopup": `components-CompanyDetails-styles___inputWrapperPopup--wbDHF`,
	"prevSelectedText": `components-CompanyDetails-styles___prevSelectedText--cc1Yb`,
	"lineBefore": `components-CompanyDetails-styles___lineBefore--ygJC8`,
	"dropdownContainer": `components-CompanyDetails-styles___dropdownContainer--QXHXM`
};
module.exports = ___CSS_LOADER_EXPORT___;
